import { defineStore } from 'pinia'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    isAuthenticated: false, // 用户登录状态
    userInfo: {},
    touristWatchList: [],
    loginDialogStatus: 0,
    confirmTitle: ''
  }),
  persist: process.client && {
    key: 'authStore',
    storage: persistedState.localStorage,
    paths: ['isAuthenticated', 'userInfo', 'loginDialogStatus', 'confirmTitle']
  },
  actions: {
    login(data: any) {
      trackEvent({ type: 'clklog', category: 'LoginWithKey', userId: data?.user_id })
      this.userInfo = data
      this.isAuthenticated = true
      // 清除缓存的视频点赞数据
      sessionStorage.removeItem('likeCountLocalCacheKey')
    },
    logout() {
      this.userInfo = {}
      this.isAuthenticated = false // 登出逻辑
      localStorage.clear()
      sessionStorage.clear()

      const inWebView = isWebView()
      if (inWebView) {
        //@ts-ignore
        if (window?.webkit?.messageHandlers?.openThirdWeb) {
          //@ts-ignore
          // window?.webkit?.messageHandlers?.cleanWebviewCache?.postMessage('ios')
          //@ts-ignore
        } else if (window?.android) {
          //@ts-ignore
          // window?.android?.cleanWebviewCache();
        } else {
          console.error('WebView detected but platform is unknown or unsupported.')
        }
      }
    }
  }
})

